import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import Cookies from "js-cookie";
import ServiceApi from "../../services/ServiceApi";
import { Select,  notification,  Button, Radio } from "antd";
// import { LoadingOutlined } from '@ant-design/icons';
// import moment, { RFC_2822 } from "moment";
import btnSearch from "./btn-search.png";
import btnComment from "./btn-Comment.png";

import './report.css';
import { connect } from "react-redux";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';

// const monthFormat = 'YYYY-MM';
const { Option } = Select;
// const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
// const url = window.location.href;
const { REACT_APP_URL_API } = process.env;
const domainReportFile = REACT_APP_URL_API.replace("/api/", "/ReportTemplate/Monthly_Report_BTS/");

const domainReport = ServiceApi.absoluteUrl("/report");

class BTSReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factUpdate: false,
      LangTranslate: [[]],
      areaId: null,
      areaCode: [],
      vendorId: null,
      vendor: null,
      vendorName: null,
      vendorList: [],
      CheckDisplayJobType: false,
      allReportColor: "#FFF",
      allReportBGColor: "#3333FF",
      myJobColor: "#000",
      myJobBGColor: "#b8b8c2",
      displayReportList: "none",
      filterDataList: [],
      periodList: [],
      periodId: null,
      considerationDisplay: "none",
      ConfirmDisplay: "none",
      messageConfirm: "You want to request process approve report?",
      reportID: 0,
      reportAreaID: "",
      DialogDisplay: "none",
      messageDialog: "",
      approveStatusID: 1,
      statusReasonID: "",
      resonData: [],
      approveID: 0,
      commentResonApprove: "",
      ConfirmApproveProcessDisplay: "none",
      linkDownload: "",
      vendorNoSelect: 0,
      startDateSelect: "",
      endDateSelect: "",
      areaIDSelect: "",
      jobTypeIDSelect: "NULL",
      payTypeIDSelect: "NULL",
      periodNameSelect: "",
      filenameSelect: "",
      tmpArea: "",
      refDocNoSelect: "",
      ConfirmDeleteDisplay: "none",
      deleteReportID: 0,
      pagination: 1
    };

    this.setArea = this.setArea.bind(this);
  }

  componentDidMount() {

    if (!((Cookies.get("companyid") == 3) && (Cookies.get("operator_id") == 4) && (Cookies.get("project_id") == 7))){
      window.location.href = domainReport+"?trs";
    }
    this.setState({ CheckDisplayJobType: false });

    ServiceApi.post("master_data/work_area_center", {
      company_id: 3,
      operator_id: 4,
      project_id: 6,
      is_activ: 1,
      where: "",
    })
      .then((res) => {
        this.setState({ areaCode: res.data.data.result });
      })
      .catch((e) => {
        console.log("error loading area code trs", e);
      });

    ServiceApi.post("get_period_report", {
      sql_where: " and type_report = 'BTS' "
    })
      .then((res) => {
        this.setState({ periodList: res.data.data });
      })
      .catch((e) => {
        console.log("error loading vendor", e);
      });
    this.loadReportList();
    this.loadStatusApprove();
  }

  loadStatusApprove() {
    var resonType = "Approve_Report";
    ServiceApi.post("get_servicemareasons", {
      company_id: "3",
      operator_id: "4",
      project_id: "7",
      ma_reason: resonType
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({ resonData: data.serult_service_reason });
        }
      })
      .catch((e) => {
        console.log("error loading get approve report file list", e);
      });
  }

  createMarkup = (object) => {
    return { __html: object };
  }

  loadReportList() {
    this.setState({allReportColor: "#FFF",
    allReportBGColor: "#3333FF",
    myJobColor: "#000",
    myJobBGColor: "#b8b8c2"})
    ServiceApi.post("Approve/get_report_approve_process", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      process_group: "Approve_Report",
      area_code: Cookies.get("userarea"),
      create_by: Cookies.get("username"),
      report_type: 0,
      vendor_id: null,
      period_id: null
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          let tmp = [];
          let tmpDisplay = [];

          data.approveProcess.map((item, index) => (

            tmp.push({
              "no": item.row_No,
              "area": item.area_id,
              "refDocNo": item.refDocNo,
              "reportName": item.file_name,
              "period": <div title={item.period_name}>{item.period_name}</div>,
              "status": <div>{item.approve_status_name}</div>,
              "comment": item.approve_comment,
              "approveStatus": item.approve_status,
              "option_approve": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/approve.svg" id={"btnApprove" + index} style={{marginRight:"0px"}} title="Approve" /></button>,
              "option_reject": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/reject.svg" id={"btnReject" + index} style={{marginRight:"0px"}} title="Reject" /></button>,
              "option_request": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/request.svg" onClick={() => this.clickSendAction(item.id, item.approve_status, item.area_id, item.approve_id, item.vendor_id, item.start_date, item.end_date, item.job_type_id, item.pay_type_id, item.period_id, item.period_name, item.file_name,item.refDocNo)} id={"btnRequest" + index} style={{marginRight:"0px"}} title="Request Approve" /></button>,
              "option_delete":<button type="button" className="btn btn-xs btn-light"><img src="/MaxiOperation/icon/bbtec/button/report/delete.svg" onClick={() => this.clickDeleteList(item.id)} id={"btnDelete" + index} style={{marginRight:"0px"}} title="Request Delete"/></button>,
              "createBy": item.create_user
            })
          ));
          for (var key in tmp) {
            var filename = tmp[key]["reportName"];
            filename = filename.replace("Monthly_Report_BTS/","");
            var filename_link = filename.replace(" ","%20");
            this.setState({ linkDownload: "<a href=" + domainReportFile + filename_link + " title=" + filename + ">" + filename + "</a> " })

            if(tmp[key]["approveStatus"] != 0){
              tmp[key]["option_delete"] = "";
            }else{
              if(tmp[key]["createBy"].toLowerCase() != Cookies.get("username").toLowerCase()){
                tmp[key]["option_delete"] = "";
              }
            }

            if(tmp[key]["comment"] != null){
              tmp[key]["comment"] = <img src={btnComment} title={tmp[key]["comment"]} />;
            }

            if(tmp[key]["approveStatus"] == 0){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 1){
              tmp[key]["option_request"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 2){
              tmp[key]["option_request"] = "";
              tmp[key]["option_approve"] = "";
            }

            if(tmp[key]["approveStatus"] == 3){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            tmpDisplay.push({
              "no": tmp[key]["no"],
              "area": (tmp[key]["area"] == "BK%")? "ALL BKK":tmp[key]["area"],
              "refDocNo": <div title={tmp[key]["refDocNo"]}>{tmp[key]["refDocNo"]}</div>,
              "reportName": <div dangerouslySetInnerHTML={{ __html: this.state.linkDownload }} />,
              "period": tmp[key]["period"],
              "status": tmp[key]["status"],
              "comment": tmp[key]["comment"],
              "option": <div>{tmp[key]["option_approve"]}{tmp[key]["option_request"]}{tmp[key]["option_reject"]}{tmp[key]["option_delete"]}</div>
            })
            this.setState({ linkDownload: "" });
          }

          this.setState({ filterDataList: tmpDisplay });
          tmp = null;
          tmpDisplay = null;
        }
      })
      .catch((e) => {
        console.log("error loading get approve report file list", e);
      });
  }

  loadReportListMyJob() {
    this.setState({allReportColor: "#000",
    allReportBGColor: "#b8b8c2",
    myJobColor: "#FFF",
    myJobBGColor: "#3333FF"});

    ServiceApi.post("Approve/get_report_approve_process", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      process_group: "Approve_Report",
      area_code: Cookies.get("userarea"),
      create_by: Cookies.get("username"),
      report_type: 1,
      vendor_id: null,
      period_id: null
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          let tmp = [];
          let tmpDisplay = [];

          data.approveProcess.map((item, index) => (

            tmp.push({
              "no": item.row_No,
              "area": item.area_id,
              "refDocNo": item.refDocNo,
              "reportName": item.file_name.split(","),
              "period": <div title={item.period_name}>{item.period_name}</div>,
              "status": <div>{item.approve_status_name}</div>,
              "comment": item.approve_comment,
              "approveStatus": item.approve_status,
              "option_approve": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/approve.svg" id={"btnApprove" + index} style={{marginRight:"0px"}} title="Approve" /></button>,
              "option_reject": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/reject.svg" id={"btnReject" + index} style={{marginRight:"0px"}} title="Reject" /></button>,
              "option_request": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/request.svg" onClick={() => this.clickSendAction(item.id, item.approve_status, item.area_id, item.approve_id, item.vendor_id, item.start_date, item.end_date, item.job_type_id, item.pay_type_id, item.period_id, item.period_name, item.file_name,item.refDocNo)} id={"btnRequest" + index} style={{marginRight:"0px"}} title="Request Approve" /></button>,
              "option_delete":<button type="button" className="btn btn-xs btn-light"><img src="/MaxiOperation/icon/bbtec/button/report/delete.svg" onClick={() => this.clickDeleteList(item.id)} id={"btnDelete" + index} style={{marginRight:"0px"}} title="Request Delete"/></button>,
              "createBy": item.create_user
            })
          ));
          for (var key in tmp) {
            for (var keyfilename in tmp[key]["reportName"]) {
              var filename = tmp[key]["reportName"][keyfilename].replace("Monthly_Report_BTS/","");
              this.setState({ linkDownload: this.state.linkDownload.toString() + "<a href=" + domainReportFile + tmp[key]["reportName"][keyfilename] + " title=" + filename + ">" + filename + "</a> " })
            }
            if(tmp[key]["approveStatus"] != 0){
              tmp[key]["option_delete"] = "";
            }else{
              if(tmp[key]["createBy"].toLowerCase() != Cookies.get("username").toLowerCase()){
                tmp[key]["option_delete"] = "";
              }
            }

            if(tmp[key]["comment"] != null){
              tmp[key]["comment"] = <img src={btnComment} title={tmp[key]["comment"]} />;
            }

            if(tmp[key]["approveStatus"] == 0){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 1){
              tmp[key]["option_request"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 2){
              tmp[key]["option_request"] = "";
              tmp[key]["option_approve"] = "";
            }

            if(tmp[key]["approveStatus"] == 3){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            tmpDisplay.push({
              "no": tmp[key]["no"],
              "area": (tmp[key]["area"] == "BK%")? "ALL BKK":tmp[key]["area"],
              "refDocNo": <div title={tmp[key]["refDocNo"]}>{tmp[key]["refDocNo"]}</div>,
              "reportName": <div dangerouslySetInnerHTML={{ __html: this.state.linkDownload }} />, //dangerouslySetInnerHTML(this.state.linkDownload),
              "period": tmp[key]["period"],
              "status": tmp[key]["status"],
              "comment": tmp[key]["comment"],
              "option": <div>{tmp[key]["option_approve"]}{tmp[key]["option_request"]}{tmp[key]["option_reject"]}{tmp[key]["option_delete"]}</div>
            })
            this.setState({ linkDownload: "" });
          }

          this.setState({ filterDataList: tmpDisplay });
          tmp = null;
          tmpDisplay = null;
        }
      })
      .catch((e) => {
        console.log("error loading get approve report file list my job", e);
      });
  }

  clickSendAction = (reportID, status, areaID, approveID, vendorNo, startDate, endDate, jobTypeID, payTypeID, peroidID, periodName, fileName, refDocNo) => {
    window.scrollTo({ top: 0 });
    this.setState({ reportID: reportID, areaIDSelect: areaID, reportAreaID: areaID, approveID: approveID, vendorNoSelect: vendorNo, startDateSelect: startDate, endDateSelect: endDate, jobTypeIDSelect: jobTypeID, payTypeIDSelect: payTypeID, periodNameSelect: periodName, filenameSelect: fileName, refDocNoSelect: refDocNo });
    if (status == 0) {
      //call api Approve/request_approve_process
      this.setState({ ConfirmDisplay: "block" });
    } else if (status == 3) {
      this.setState({ considerationDisplay: "block" });
    }
  }

  clickDeleteList = (reportID) => {
    this.setState({ deleteReportID: reportID,ConfirmDeleteDisplay: "block" });
  }

  onCallSendRequestApproveProcess = () => {
    this.setState({ ConfirmDisplay: "none" });
    let SubProcessID = 2;
    let from_sub_process_id = 2;
    // Open Approve/request_approve_process
    ServiceApi.post("Approve/request_approve_process", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_id: this.state.reportID,
      wf_id: 58,
      MainProcessID: 999,
      SubProcessID: SubProcessID,
      from_sub_process_id: from_sub_process_id,
      next_main_action_id: 7,
      process_group: "Approve_Report",
      action_type: this.state.reportAreaID,
      reference_id: this.state.reportID,
      create_by: Cookies.get("username"),
      TokenUser: Cookies.get(`OperationToken`),
      refDocNo: this.state.refDocNoSelect,
      vendor_id: this.state.vendorNoSelect
    })
      .then((res) => {
        console.log("request approve process");
        if (res.data.result.code === "P") {
          // update set approve_id of file report
          ServiceApi.post("update_approve_report_file_list", {
            approve_id: res.data.result.value,
            report_id: this.state.reportID,
            approve_status: 3
          })
            .then((res) => {

              if (res.data.result.code === "P") {
                // update set approve_id of file report ok
                this.setState({ DialogDisplay: "block", messageDialog: "Send request approve report successfully" });
                console.log("update set approve_id of file report ok");
              }
            })
            .catch((e) => {
              this.setState({ DialogDisplay: "block", messageDialog: "Error: Send request approve report: " + e });
              console.log("error update set approve_id of file report not ok", e);
            });

          this.notify("info", "Informaton", "send request approve report file");

        }
      })
      .catch((e) => {
        console.log("error send request approve report file", e);
      });

    // Close Approve/request_approve_process
  }

  setArea = (value) => {
    this.setState({ areaId: value });
    ServiceApi.post("master_data/GetTeamGroupAreaReport", {
      company_id: 3,
      operator_id: 4,
      project_id: 7,
      team_group_duty_code: "O",
      area_code: value,
    })
      .then((res) => {
        this.setState({ vendorList: res.data.list });
      })
      .catch((e) => {
        console.log("error loading area", e);
      });
  };

  setVendor = (value) => {
    this.setState({ vendorId: value });
  };

  setPeriodReport = (value) => {
    this.setState({ periodId: value });
  }

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  onSearch = () => {
    this.setState({allReportColor: "#FFF",
    allReportBGColor: "#3333FF",
    myJobColor: "#000",
    myJobBGColor: "#b8b8c2"})

    let area = this.state.areaId;

    if(area == "NULL") {
      area = Cookies.get("userarea");
    }

    ServiceApi.post("Approve/get_report_approve_process", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      process_group: "Approve_Report",
      area_code: area,
      create_by: Cookies.get("username"),
      report_type: 0,
      vendor_id: this.state.vendorId,
      period_id: this.state.periodId
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          let tmp = [];
          let tmpDisplay = [];

          data.approveProcess.map((item, index) => (

            tmp.push({
              "no": item.row_No,
              "area": item.area_id,
              "refDocNo": item.refDocNo,
              "reportName": item.file_name.split(","),
              "period": <div title={item.period_name}>{item.period_name}</div>,
              "status": <div>{item.approve_status_name}</div>,
              "comment": item.approve_comment,
              "approveStatus": item.approve_status,
              "option_approve": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/approve.svg" id={"btnApprove" + index} style={{marginRight:"0px"}} title="Approve" /></button>,
              "option_reject": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/reject.svg" id={"btnReject" + index} style={{marginRight:"0px"}} title="Reject" /></button>,
              "option_request": <button type="button" className="btn btn-xs"><img src="/MaxiOperation/icon/bbtec/button/report/request.svg" onClick={() => this.clickSendAction(item.id, item.approve_status, item.area_id, item.approve_id, item.vendor_id, item.start_date, item.end_date, item.job_type_id, item.pay_type_id, item.period_id, item.period_name, item.file_name,item.refDocNo)} id={"btnRequest" + index} style={{marginRight:"0px"}} title="Request Approve" /></button>,
              "option_delete":<button type="button" className="btn btn-xs btn-light"><img src="/MaxiOperation/icon/bbtec/button/report/delete.svg" onClick={() => this.clickDeleteList(item.id)} id={"btnDelete" + index} style={{marginRight:"0px"}} title="Request Delete"/></button>,
              "createBy": item.create_user
            })
          ));
          for (var key in tmp) {
            for (var keyfilename in tmp[key]["reportName"]) {
              var filename = tmp[key]["reportName"][keyfilename].replace("Monthly_Report_BTS/","");
              this.setState({ linkDownload: this.state.linkDownload.toString() + "<a href=" + domainReportFile + tmp[key]["reportName"][keyfilename] + " title=" + filename + ">" + filename + "</a> " })
            }
            if(tmp[key]["approveStatus"] != 0){
              tmp[key]["option_delete"] = "";
            }else{
              if(tmp[key]["createBy"].toLowerCase() != Cookies.get("username").toLowerCase()){
                tmp[key]["option_delete"] = "";
              }
            }

            if(tmp[key]["comment"] != null){
              tmp[key]["comment"] = <img src={btnComment} title={tmp[key]["comment"]} />;
            }

            if(tmp[key]["approveStatus"] == 0){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 1){
              tmp[key]["option_request"] = "";
              tmp[key]["option_reject"] = "";
            }

            if(tmp[key]["approveStatus"] == 2){
              tmp[key]["option_request"] = "";
              tmp[key]["option_approve"] = "";
            }

            if(tmp[key]["approveStatus"] == 3){
              tmp[key]["option_approve"] = "";
              tmp[key]["option_reject"] = "";
            }

            tmpDisplay.push({
              "no": tmp[key]["no"],
              "area": (tmp[key]["area"] == "BK%")? "ALL BKK":tmp[key]["area"],
              "refDocNo": <div title={tmp[key]["refDocNo"]}>{tmp[key]["refDocNo"]}</div>,
              "reportName": <div dangerouslySetInnerHTML={{ __html: this.state.linkDownload }} />, //dangerouslySetInnerHTML(this.state.linkDownload),
              "period": tmp[key]["period"],
              "status": tmp[key]["status"],
              "comment": tmp[key]["comment"],
              "option": <div>{tmp[key]["option_approve"]}{tmp[key]["option_request"]}{tmp[key]["option_reject"]}{tmp[key]["option_delete"]}</div>
            })
            this.setState({ linkDownload: "" });
          }

          this.setState({ filterDataList: tmpDisplay });
          tmp = null;
          tmpDisplay = null;
        }
      })
      .catch((e) => {
        console.log("error loading get approve report file list", e);
      });
  };

  sendBack = () => {
    this.setState({ considerationDisplay: "none" })
  }

  onCloseConfirmWindow = () => {
    this.setState({ ConfirmDisplay: "none" });
  }

  onCloseDialogWindow = () => {
    this.setState({ DialogDisplay: "none" });
    window.location.href = domainReport+"?bts";
  }

  setApproveType = (event) => {
    this.setState({ approveStatusID: event.target.value, statusReasonID: "", resonData: [] });
    var resonType = "Approve_Report";
    if (event.target.value == 2) {
      resonType = "Reject_Report";
    }

    ServiceApi.post("get_servicemareasons", {
      company_id: "3",
      operator_id: "4",
      project_id: "7",
      ma_reason: resonType
    })
      .then((res) => {
        const { result, data } = res.data;
        if (result.code === "P") {
          this.setState({ resonData: data.serult_service_reason });
        }
      })
      .catch((e) => {
        console.log("error loading get approve report file list", e);
      });
  }

  setResonApprove = (e) => {
    this.setState({ statusReasonID: e.target.value });
  }

  onCancelApproveProcess = () => {
    this.setState({ considerationDisplay: "none" });
  }

  setCommentResonApprove = (e) => {
    this.setState({ commentResonApprove: e.target.value });
  }

  onConfirmApproveProcess = () => {
    this.setState({ ConfirmApproveProcessDisplay: "block", considerationDisplay: "none" });
  }

  onCloseConfirmApproveProcessDisplay = () => {
    this.setState({ ConfirmApproveProcessDisplay: "none" });
  }

  onCallApproveProcess = () => {
    this.setState({ ConfirmApproveProcessDisplay: "none" });
    //check value input
    let error = 0;
    if (this.state.statusReasonID == "") {
      this.notify("info", "Informaton", "Please select reson before");
      error = 1;
    }
    if (this.state.approveStatusID == 2) {
      if (this.state.commentResonApprove.length == 0) {
        this.notify("info", "Informaton", "Please input comment consideration before");
        error = 1;
      }
    }
    if (error == 0) {
      ServiceApi.post("Approve/update_report_approve_process", {
        company_id: Number(Cookies.get("companyid")),
        operator_id: Number(Cookies.get("operator_id")),
        project_id: Number(Cookies.get("project_id")),
        process_group: "Approve_Report",
        area_code: this.state.reportAreaID,
        create_by: Cookies.get("username"),
        approve_status_id: this.state.approveStatusID,
        approve_level_seq: "1",
        approve_id: this.state.approveID,
        reference_id: this.state.reportID,
        //approve_date: moment().format('YYYY-MM-DD HH:mm:ss'),
        status_reason_id: this.state.statusReasonID,
        status_remark: this.state.commentResonApprove
      })
        .then((res) => {
          const { result, data } = res.data;
          if (result.code === "P") {
            console.log("status:" + data.process_Status[0].approve_status_name);
            //check approve_status_name = "Approve" send data to PM&M
            if (data.process_Status[0].approve_status_name == "Approve") {
              console.log("DM Approve pass");
              // update approve_status = 1
              ServiceApi.post("update_approve_report_file_list", {
                report_id: this.state.reportID,
                approve_status: 1
              })
                .then((res) => {
                  if (res.data.result.code === "P") {
                    console.log("update set approve_status = 1");
                  }
                })
                .catch((e) => {
                  this.setState({ DialogDisplay: "block", messageDialog: "Error: Send request approve report: " + e });
                  console.log("error update set approve_status = 1", e);
                });

              // 1.Send data to API "/api/IMPSourceBOQPay/ImportSourceBOQ"
              /*
              ServiceApi.post("import_Source_BOQ", {
                companyID: Number(Cookies.get("companyid")),
                operatorID: Number(Cookies.get("operator_id")),
                projectID: Number(Cookies.get("project_id")),
                vendorNo: this.state.vendorNoSelect,
                startDate: this.state.startDateSelect + " 00:00:00",
                endDate: this.state.endDateSelect + " 23:59:59",
                areaID: this.state.areaIDSelect,
                jobTypeID: this.state.jobTypeIDSelect,
                payTypeID: this.state.payTypeIDSelect
              })
                .then((res) => {
                  const { result, data } = res.data;
                  if (result.code === "P") {
                    console.log("send data to PM&M API IMPSourceBOQPay/import_Source_BOQ");
                    // 2.Send data to API "/api/IMPSourceBOQPay/ImportSourceBOQAttachmentFile" 
                    var refDocNo = result.value;
                    var documentName = result.value;
                    var documentType = 4;
                    var filename = this.state.filenameSelect.replace(".xls", ".pdf");
                    var pathFileReportPDF = domainReportFile + filename;
                    this.send2PMAndM(refDocNo, 1, "1/1", documentName, documentType, pathFileReportPDF);
                    console.log("send data to PM&M API IMPSourceBOQPay/ImportSourceBOQAttachmentFile");
                    this.setState({ DialogDisplay: "block", messageDialog: "Send data to PM&M Successfully" });
                    //3.Send data to API "/api/IMPSourceBOQPay/ImportSourceBOQHistoryApprove"
                    /*ServiceApi.post("import_Source_BOQ_History_Approve", {
                      report_id: this.state.reportID,
                    })
                    .then((res) => {
                      const { result, data } = res.data;
                      if (result.code === "P") {

                      }
                    })
                    .catch((e) => {
                        console.log("error send data to PM&M", e);
                    });

                  }
                })
                .catch((e) => {
                  console.log("error send data to PM&M", e);
                });
                */
              this.setState({ DialogDisplay: "block", messageDialog: "Send Consideration Successfully" });
            } else {
              this.setState({ DialogDisplay: "block", messageDialog: "Send Consideration Successfully" });
            }


          }
        })
        .catch((e) => {
          console.log("error loading get approve report file list", e);
        });
    }
  }

  onCallDeleteReport = () =>{
    this.setState({ConfirmDeleteDisplay : "none"});
    ServiceApi.post("delete_report_file_list", {
      report_id: this.state.deleteReportID
    })
      .then((res) => {
        if (res.data.result.code === "P") {
          this.setState({ DialogDisplay: "block", messageDialog: "Delete report already."});
          console.log("Delete report file list ID: "+this.state.deleteReportID);
        }
      })
      .catch((e) => {
        this.setState({ DialogDisplay: "block", messageDialog: "Error: Delete report: " + e });
        console.log("error delete report file list", e);
      });
  }

  onCloseConfirmDeleteWindow = () =>{
    this.setState({ConfirmDeleteDisplay : "none"})
  }

  render() {
    const locale = Cookies.get("locale");

    const columns = [
      {
        name: `No`,
        selector: 'no',
        sortable: true,
        width: "5%",
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["Area"] : `Area`,
        selector: 'area',
        sortable: true,
        width: "10%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["refDocNo"] : `RefDocNo`,
        selector: 'refDocNo',
        sortable: true,
        width: "15%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["reportName"] : 'Report name',
        selector: 'reportName',
        sortable: true,
        width: "30%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["periodReport"] : 'Period',
        selector: 'period',
        sortable: true,
        width: "10%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["Status"] : 'Status',
        selector: 'status',
        sortable: true,
        width: "10%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["Comment"] : 'Comment',
        selector: 'comment',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        style: 'cursor:pointer',
        width: "10%"
      },
      {
        name: (this.state.factUpdate) ? this.state.LangTranslate[locale]["Action"] : 'Action',
        selector: 'option',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        style: '-webkit-justify-content:unset !important',
        width: "10%"
      }
    ];

    return (
      <div className="report-header row" style={{ position: "absolute", backgroundColor: "white", width: "100%", zIndex: 100 }}>

        <div className="col-sm-12">
          <img
            src={ServiceApi.absoluteUrl(
              "/icon/icon_select_report.svg"
            )}
            alt="Select report"
            title="Select report"
          />
          (BTS) Fault Monthly Report
        </div>
        <div className="col-sm-12" >
          <div style={{ border: "1px solid #00F", padding: "10px", marginTop: "10px", width: "95%", fontSize: "14px" }}>
            <div className="report-header" >Search</div>
            <div>{this.props.langUpdate
              ? this.props.langData[locale]["areaName"]
              : "Area name"} <Select
                style={{ width: "200px" }}
                showSearch
                placeholder="Select area"
                value={this.state.areaId}
                onSelect={this.setArea}
              >
                <Option value="NULL" className="default-thai-font">
                  ALL Area
                </Option>
                <Option value="BK%" className="default-thai-font">
                  ALL_BKK
                </Option>
                {this.state.areaCode.map((item, index) => (
                  <Option value={item.area_code} key={index}>
                    <span className="default-thai-font">{item.area_code}</span>
                  </Option>
                ))}
              </Select> {this.props.langUpdate
                ? this.props.langData[locale]["vendor"]
                : "Vendor"}&nbsp;
              <Select
                style={{ width: "200px" }}
                showSearch
                placeholder="Select vendor"
                value={this.state.vendorId}
                onSelect={this.setVendor}
              >
                <Option value=""></Option>
                {this.state.vendorList.map((item, index) => (
                  <Option
                    value={item.vendor_id}
                    key={index}
                  >
                    <span className="default-thai-font">
                      {item.team_group_name}
                    </span>
                  </Option>
                ))}
              </Select> &nbsp;
              {this.props.langUpdate
                ? this.props.langData[locale]["periodReport"]
                : "Period"}
              <Select
                style={{ width: "120px", paddingLeft: "10px" }}
                showSearch
                placeholder="Select period"
                value={this.state.periodId}
                onSelect={(value) => this.setPeriodReport(value)}
              >
                <Option value="NULL" className="default-thai-font">SELECT PERIOD</Option>
                {this.state.periodList.map((item, index) => (
                  <Option
                    value={item.period_id}
                    key={index}
                  >
                    <span className="default-thai-font">
                      {item.period_name}
                    </span>
                  </Option>
                ))}
              </Select>
              <img src={btnSearch} onClick={() => this.onSearch()} style={{ marginTop: "-7px", marginLeft: "10px", cursor: "pointer" }} />
            </div>

          </div>
        </div>

        <div className="col-sm-12 mt-2" style={{ backgroundColor: "white" }}>
          <button className="btn" onClick={()=>this.loadReportList()} style={{ backgroundColor: this.state.allReportBGColor, color: this.state.allReportColor }} >ALL REPORT</button>
          <button className="btn" onClick={()=>this.loadReportListMyJob()} style={{ backgroundColor: this.state.myJobBGColor, color: this.state.myJobColor }} >MY JOB</button>

          <DataTable
            style={{ fontSize: "20px"}}
            columns={columns}
            data={this.state.filterDataList}
            paginationPerPage={15}
            pagination={true}
            fixedHeader={true}
            striped={true}
            highlightOnHover={true}
            persistTableHead={true}
            overflowY={true}
            overflowX={true}
          />


        </div>

        <div id="ConsiderationWindow" style={{ display: this.state.considerationDisplay, width: "620px", height: "425px", border: "10px solid #0050A3", backgroundColor: "white", position: "absolute", top: "20px", left: "50%", marginLeft: "-310px", padding: "20px" }}>
          <div style={{ borderBottom: "2px solid #0050A3", width: "100%", paddingBottom: "10px", color: "black" }}>Consideration</div>
          <div style={{ padding: "15px 0px" }} className="row">
            <div style={{ width: "150px" }}><i style={{ color: "#F00" }}>*</i> Approve Type:</div>
            <div>
              <Radio.Group onChange={this.setApproveType} defaultValue={this.state.approveStatusID}>
                <Radio value={1}>Approve</Radio>
                <Radio value={2}>Reject</Radio>
              </Radio.Group>
            </div>
          </div>
          <div style={{ padding: "15px 0px" }} className="row">
            <div style={{ width: "150px" }}><i style={{ color: "#F00" }}>*</i> Reson:</div>
            <div><select
              id="Reson"
              placeholder="Please select"
              className="dropdrowtype select-problem-type form-select"
              onChange={(e) => this.setResonApprove(e)}
              value={this.state.statusReasonID}
              required
              style={{ width: "400px", fontSize: "14px" }}
            >
              <option value="" className="please-select">PLEASE SELECT</option>
              {this.state.resonData.map((item, index) => (
                <option
                  value={item.service_ma_reason_id}
                  key={`layoutoption_${index}`}
                >
                  {item.service_ma_reason_desc}
                </option>
              ))}
            </select></div>
          </div>
          <div style={{ padding: "15px 0px" }} className="row">
            <div style={{ width: "150px" }}>Comment:</div>
            <div><textarea id="commentResonApprove" value={this.state.commentResonApprove} style={{ width: "400px" }} rows="5" onChange={this.setCommentResonApprove} /></div>
          </div>
          <div style={{ textAlign: "center" }}><button className="btn btn-reject" onClick={() => this.onCancelApproveProcess()}>Cancel</button>&nbsp;<button className="btn btn-confirm" onClick={() => this.onConfirmApproveProcess()}>Confirm</button></div>
        </div>

        <div id="ConfirmWindow" className="confirm-window" style={{
          position: 'absolute', left: '50%', top: '20%',
          transform: 'translate(-50%, -20%)',
          display: this.state.ConfirmDisplay
        }}>
          <div className="row">
            <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
              <div style={{ fontSize: "14px" }}>{this.state.messageConfirm}</div>
            </div>
          </div>
          <div className="row row-add">
            <div className="col-sm-12 m-0 p-0 text-center"><Button type="primary" onClick={this.onCallSendRequestApproveProcess}>&nbsp;&nbsp;YES&nbsp;&nbsp;</Button> <Button type="primary" onClick={this.onCloseConfirmWindow}>&nbsp;&nbsp;NO&nbsp;&nbsp;</Button></div>
          </div>
        </div>

        <div id="ConfirmDeleteDisplay" className="confirm-window" style={{
          position: 'absolute', left: '50%', top: '20%',
          transform: 'translate(-50%, -20%)',
          display: this.state.ConfirmDeleteDisplay
        }}>
          <div className="row">
            <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
              <div style={{ fontSize: "14px" }}>Are you want to delete report?</div>
            </div>
          </div>
          <div className="row row-add">
            <div className="col-sm-12 m-0 p-0 text-center"><Button type="primary" onClick={this.onCallDeleteReport}>&nbsp;&nbsp;YES&nbsp;&nbsp;</Button> <Button type="primary" onClick={this.onCloseConfirmDeleteWindow}>&nbsp;&nbsp;NO&nbsp;&nbsp;</Button></div>
          </div>
        </div>


        <div id="ConfirmApproveProcessDisplay" className="confirm-window" style={{
          position: 'absolute', left: '50%', top: '20%',
          transform: 'translate(-50%, -20%)',
          display: this.state.ConfirmApproveProcessDisplay
        }}>
          <div className="row">
            <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
              <div style={{ fontSize: "14px" }}>You want to Approve Process Report?</div>
            </div>
          </div>
          <div className="row row-add">
            <div className="col-sm-12 m-0 p-0 text-center"><Button type="primary" onClick={this.onCallApproveProcess}>&nbsp;&nbsp;YES&nbsp;&nbsp;</Button> <Button type="primary" onClick={this.onCloseConfirmApproveProcessDisplay}>&nbsp;&nbsp;NO&nbsp;&nbsp;</Button></div>
          </div>
        </div>

        <div id="DialogWindow" className="confirm-window" style={{
          position: 'absolute', left: '50%', top: '20%',
          transform: 'translate(-50%, -20%)',
          display: this.state.DialogDisplay
        }}>
          <div className="row">
            <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
              <div style={{ fontSize: "14px" }}>{this.state.messageDialog}</div>
            </div>
          </div>
          <div className="row row-add">
            <div className="col-sm-12 m-0 p-0 text-center"><Button type="primary" onClick={this.onCloseDialogWindow}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button></div>:
          </div>
        </div>

      </div>


    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(BTSReport);
